import axios from "axios";
import store from "@/app/store";
import { logoutUser, refreshAccessToken } from "@/features/auth/authThunks";

const api = axios.create({
  baseURL: import.meta.env.VITE_BACKEND_URL, // Asegurarse de configurar esta variable de entorno
  headers: { "Content-Type": "application/json" }, // Ajusta según tus necesidades
  withCredentials: true, // Si usas cookies para autenticación
});

const apiAuth = axios.create({
  baseURL: import.meta.env.VITE_BACKEND_URL, // Asegurarse de configurar esta variable de entorno
  withCredentials: true, // Si usas cookies para autenticación
});

// 🔸 Interceptor para manejar errores 401 y refrescar token
let isRefreshing = false;
let refreshSubscribers = [];
// debugger;

// ✅ Manejo de cola cuando hay múltiples requests durante el refresh
// Notificar a todos los suscriptores con el nuevo token
const notifyTokenRefresh = (tokens) => {
  refreshSubscribers.forEach((callback) => callback(tokens));
  refreshSubscribers = [];
};
// debugger;
// Función para agregar request a la cola
const addRefreshSubscriber = (callback) => {
  refreshSubscribers.push(callback);
};
// debugger;

const NEGATIVE_DAYS_IN_SECONDS = -1 * (7 * 24 * 60 * 60); // -7 days in seconds
// Interceptor de requests
api.interceptors.request.use(
  async (config) => {
    // debugger;
    const state = store.getState();
    let accessToken = state.auth.accessToken;
    let idToken = state.auth.idToken;
    const { user } = state.auth;
    // debugger;

    // Si no hay tokens, continuar sin autenticación
    if (!accessToken || !idToken) {
      // debugger;
      return config;
    }

    const currentTime = Math.floor(Date.now() / 1000);
    const timeUntilExpiry = user.expire - currentTime;
    // debugger;
    console.log(
      "Tiempo hasta expiración del token (segundos):",
      timeUntilExpiry
    );

    // Si el token expira en menos de 60 segundos O ya expiró (pero no hace más de 7 días)
    if (timeUntilExpiry < 60 && timeUntilExpiry > NEGATIVE_DAYS_IN_SECONDS) {
      // -600 = hace 10 minutos
      console.log(
        "Token próximo a expirar o expirado, intentando refrescar..."
      );
      // debugger;
      // Si ya hay un refresh en proceso, agregar esta request a la cola
      if (isRefreshing) {
        console.log("Refresh en proceso, agregando request a la cola...");
        console.log(
          "Número de requests en cola:",
          refreshSubscribers.length + 1
        );
        // debugger;
        return new Promise((resolve, reject) => {
          addRefreshSubscriber((tokens) => {
            if (tokens) {
              config.headers.authorization = `Bearer ${tokens.accessToken} ${tokens.idToken}`;
              resolve(config);
            } else {
              reject(new Error("Token refresh failed"));
            }
          });
        });
        // debugger;
      }

      isRefreshing = true;
      try {
        // debugger;
        const result = await store.dispatch(refreshAccessToken());
        // debugger;
        if (result.type === "auth/refreshAccessToken/fulfilled") {
          // Obtener el nuevo token del resultado
          accessToken = result.payload?.AuthenticationResult?.AccessToken;
          idToken = idToken; // TODO: Verificar si es necesario actualizar el idToken
          console.log("Tokens refrescados exitosamente");
          // debugger;
          // Notificar a todos los requests en cola
          notifyTokenRefresh({ accessToken, idToken });
          // debugger;
        } else {
          console.error("Error al refrescar token:", result.payload);
          // Notificar a todos los requests en cola que falló
          // debugger;
          notifyTokenRefresh(null);
          store.dispatch(logoutUser());
          // debugger;
          return Promise.reject(new Error("Token refresh failed"));
        }
      } catch (error) {
        console.error("Error al refrescar el token:", error);
        // Notificar a todos los requests en cola que falló
        notifyTokenRefresh(null);
        store.dispatch(logoutUser());
        return Promise.reject(error);
      } finally {
        isRefreshing = false;
      }
    } else if (timeUntilExpiry <= NEGATIVE_DAYS_IN_SECONDS) {
      console.log("Token expirado hace más de 7 días, cerrando sesión...");
      store.dispatch(logoutUser());
      return Promise.reject(new Error("Token expired"));
    }

    // Agregar ambos tokens al header si están disponibles
    if (accessToken && idToken) {
      config.headers.authorization = `Bearer ${accessToken} ${idToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

function onRefreshed(tokens) {
  refreshSubscribers.forEach((callback) => callback(tokens));
  refreshSubscribers = [];
}

// Interceptor de responses
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config;
    // debugger;
    // Si al hacer log-in da un error 401(que es por que las credenciales son incorrectas), no intentar refresh y devolver el error para mostrar mensaje al usuario
    if (originalRequest.url.includes("/auth/log-in") && error.response?.status === 401) {
      // debugger;
      return Promise.reject(error);
    }
    // debugger;

    // Solo intentar refrescar si es un error 401 y no se ha reintentado y no es la request de log-in
    if (error.response?.status === 401 && !originalRequest._retry && !originalRequest.url.includes("/auth/log-in")) {
      originalRequest._retry = true;
      // debugger;
      // Verificar si ya hay un refresh en proceso
      if (isRefreshing) {
        console.log(
          "Refresh en proceso (response interceptor), agregando request a la cola..."
        );
        // debugger;
        return new Promise((resolve, reject) => {
          addRefreshSubscriber((tokens) => {
            if (tokens) {
              originalRequest.headers.authorization = `Bearer ${tokens.accessToken} ${tokens.idToken}`;
              resolve(api(originalRequest));
            } else {
              reject(error);
            }
          });
        });
      }

      isRefreshing = true;

      try {
        // debugger;
        console.log("Iniciando refresh desde response interceptor...");
        const { payload } = await store.dispatch(refreshAccessToken());
        // debugger;
        if (payload?.AuthenticationResult?.AccessToken && payload?.AuthenticationResult?.IdToken) {
          const newAccessToken = payload.AuthenticationResult.AccessToken;
          const newIdToken = payload.AuthenticationResult.IdToken;
          console.log(
            "Tokens refrescados exitosamente desde response interceptor"
          );
          // debugger;
          // Notificar a todos los requests en cola
          onRefreshed({ accessToken: newAccessToken, idToken: newIdToken });
          // debugger;
          // Reintentar la request original
          originalRequest.headers.authorization = `Bearer ${newAccessToken} ${newIdToken}`;
          return api(originalRequest);
        } else {
          throw new Error("No se obtuvo un nuevo token");
        }
      } catch (err) {
        // debugger;
        console.error("Error en refresh desde response interceptor:", err);
        onRefreshed(null);
        // debugger;
        store.dispatch(logoutUser());
        // debugger;
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default api;
export { apiAuth };
